export const NURSING_LIST = [
  {
    wardName: "CCU1",
    bedNumber: 101,
    uhid: "KSG-24-0000001",
    patientName: "John Doe",
    age: 45,
    gender: "Male",
    admissionDate: "2025/01/20",
    bedStatus: "Occupied",
    doctorName: "Dr. Sarah Johnson",
  },
  {
    wardName: "CCU2",
    bedNumber: 202,
    uhid: "KSG-24-0000002",
    patientName: "Jane Smith",
    age: 56,
    gender: "Female",
    admissionDate: "2025/01/18",
    bedStatus: "Occupied",
    doctorName: "Dr. Michael Brown",
  },
  {
    wardName: "ICU1",
    bedNumber: 303,
    uhid: "KSG-24-0000003",
    patientName: "Tommy Lee",
    age: 8,
    gender: "Male",
    admissionDate: "2025/01/25",
    bedStatus: "Available",
    doctorName: "Dr. Emily Davis",
  },
  {
    wardName: "ICU2",
    bedNumber: 404,
    uhid: "KSG-24-0000004",
    patientName: "Nancy Wilson",
    age: 34,
    gender: "Female",
    admissionDate: "2025/01/22",
    bedStatus: "Occupied",
    doctorName: "Dr. Robert Martin",
  },
];

export const NURSING_ALL_MEDICATION_TRACKING_LIST = [
  {
    sno: 1,
    uhid: "KSG-24-0000005",
    date: "2025-01-28",
    status: "Pending",
    medicineName: "Paracetamol",
    ward: "Ward A",
    bedNumber: "12",
    requestedQuantity: 10,
    delivered: 5,
  },
  {
    sno: 2,
    uhid: "KSG-24-0000006",
    date: "2025-01-27",
    status: "Approved",
    medicineName: "Ibuprofen",
    ward: "Ward B",
    bedNumber: "8",
    requestedQuantity: 20,
    delivered: 20,
  },
  {
    sno: 3,
    uhid: "KSG-24-0000007",
    date: "2025-01-26",
    status: "Delivered",
    medicineName: "Amoxicillin",
    ward: "Ward C",
    bedNumber: "5",
    requestedQuantity: 15,
    delivered: 10,
  },
  {
    sno: 4,
    uhid: "KSG-24-0000008",
    date: "2025-01-25",
    status: "Pending",
    medicineName: "Cetirizine",
    ward: "Ward D",
    bedNumber: "3",
    requestedQuantity: 5,
    delivered: 0,
  },
  {
    sno: 5,
    uhid: "KSG-24-0000009",
    date: "2025-01-24",
    status: "Approved",
    medicineName: "Metformin",
    ward: "Ward E",
    bedNumber: "7",
    requestedQuantity: 30,
    delivered: 30,
  },
];

export const NURSING_APPROVALS = [
  {
    uhid: "KSG-24-0000005",
    date: "2025-01-28",
    patientName: "John Doe",
    ward: "Ward A",
    bed: "12",
    newWard: "Ward B",
    newBed: "8",
    requestType: "Pending",
  },
  {
    uhid: "KSG-24-0000006",
    date: "2025-01-27",
    patientName: "Jane Smith",
    ward: "Ward C",
    bed: "5",
    newWard: "Ward D",
    newBed: "10",
    requestType: "Pending",
  },
  {
    uhid: "KSG-24-0000007",
    date: "2025-01-26",
    patientName: "Alice Johnson",
    ward: "Ward B",
    bed: "7",
    newWard: "Ward A",
    newBed: "3",
    requestType: "Approved",
  },
  {
    uhid: "KSG-24-0000008",
    date: "2025-01-25",
    patientName: "Michael Brown",
    ward: "Ward E",
    bed: "2",
    newWard: "Ward F",
    newBed: "6",
    requestType: "Pending",
  },
  {
    uhid: "KSG-24-0000009",
    date: "2025-01-24",
    patientName: "Emily Davis",
    ward: "Ward D",
    bed: "9",
    newWard: "Ward C",
    newBed: "1",
    requestType: "Approved",
  },
];

export const NURSING_BED_HISTORY = [
  {
    date: "2025-01-28",
    oldWard: "Ward A",
    oldRoom: "Room 101",
    newWard: "Ward B",
    newRoom: "Room 202",
    approvedBy: "Dr. Smith",
    reason: "Better monitoring required",
  },
  {
    date: "2025-01-27",
    oldWard: "Ward C",
    oldRoom: "Room 305",
    newWard: "Ward D",
    newRoom: "Room 402",
    approvedBy: "Dr. Johnson",
    reason: "Proximity to ICU",
  },
  {
    date: "2025-01-26",
    oldWard: "Ward E",
    oldRoom: "Room 203",
    newWard: "Ward F",
    newRoom: "Room 301",
    approvedBy: "Dr. Brown",
    reason: "Specialist availability",
  },
  {
    date: "2025-01-25",
    oldWard: "Ward G",
    oldRoom: "Room 404",
    newWard: "Ward H",
    newRoom: "Room 101",
    approvedBy: "Dr. Davis",
    reason: "Room maintenance",
  },
  {
    date: "2025-01-24",
    oldWard: "Ward I",
    oldRoom: "Room 502",
    newWard: "Ward J",
    newRoom: "Room 601",
    approvedBy: "Dr. Taylor",
    reason: "Patient preference",
  },
];

export const NURSING_UNIT_TRANSFER_HISTORY = [
  {
    date: "2025-01-28",
    transferToUnit: "ICU",
    doctorName: "Dr. Smith",
    confirmedDate: "2025-01-29",
    status: "Pending",
  },
  {
    date: "2025-01-27",
    transferToUnit: "Ward A",
    doctorName: "Dr. Johnson",
    confirmedDate: "2025-01-28",
    status: "Completed",
  },
  {
    date: "2025-01-26",
    transferToUnit: "Isolation Unit",
    doctorName: "Dr. Brown",
    confirmedDate: "2025-01-27",
    status: "In Progress",
  },
  {
    date: "2025-01-25",
    transferToUnit: "General Ward",
    doctorName: "Dr. Davis",
    confirmedDate: "2025-01-26",
    status: "Completed",
  },
  {
    date: "2025-01-24",
    transferToUnit: "Pediatrics",
    doctorName: "Dr. Taylor",
    confirmedDate: "2025-01-25",
    status: "Pending",
  },
];

export const PATHOLOGY_LIST = [
  {
    id: 1,
    date: "2025-01-30",
    testName: "Blood Test",
    name: "John Doe",
    wardName: "Ward A",
    bedNumber: "12",
    doctorName: "Dr. Smith",
    status: "Pending",
  },
  {
    id: 2,
    date: "2025-01-29",
    testName: "X-Ray",
    name: "Jane Doe",
    wardName: "Ward B",
    bedNumber: "8",
    doctorName: "Dr. Brown",
    status: "Completed",
  },
  {
    id: 3,
    date: "2025-01-28",
    testName: "MRI",
    name: "Alice Johnson",
    wardName: "Ward C",
    bedNumber: "5",
    doctorName: "Dr. Green",
    status: "In Progress",
  },
  {
    id: 4,
    date: "2025-01-27",
    testName: "CT Scan",
    name: "Bob Williams",
    wardName: "Ward A",
    bedNumber: "3",
    doctorName: "Dr. Wilson",
    status: "Pending",
  },
  {
    id: 5,
    date: "2025-01-26",
    testName: "ECG",
    name: "Emily Davis",
    wardName: "Ward D",
    bedNumber: "10",
    doctorName: "Dr. Taylor",
    status: "Completed",
  },
];

export const DOCTORS_UNIT_SETTING = [
  { id: "1", doctorName: "Dr. John Doe" },
  { id: "2", doctorName: "Dr. Alice Smith" },
  { id: "3", doctorName: "Dr. Robert Brown" },
  { id: "4", doctorName: "Dr. Emily Davis" },
  { id: "5", doctorName: "Dr. Michael Johnson" },
  { id: "6", doctorName: "Dr. Sarah Wilson" },
  { id: "7", doctorName: "Dr. David Martinez" },
  { id: "8", doctorName: "Dr. Laura White" },
  { id: "9", doctorName: "Dr. Richard Thomas" },
  { id: "10", doctorName: "Dr. Jessica Lee" },
];
export const MASTER_RELIEF_TEST_DATAS = [
  {
    id: 1,
    reliefType: "Medical Aid",
    name: "John Doe",
    code: "MED123",
  },
  {
    id: 2,
    reliefType: "Financial Assistance",
    name: "Jane Smith",
    code: "FIN456",
  },
  {
    id: 3,
    reliefType: "Disaster Relief",
    name: "Alice Johnson",
    code: "DIS789",
  },
  {
    id: 4,
    reliefType: "Education Grant",
    name: "Bob Brown",
    code: "EDU101",
  },
];
export const MASTER_POLICY_DATA = [
  {
    id: 1,
    name: "John Doe",
    scheme: "Premium Plan",
    active: "Active",
  },
  {
    id: 2,
    name: "Jane Smith",
    scheme: "Basic Plan",
    active: "Inactive",
  },
  {
    id: 3,
    name: "Alice Johnson",
    scheme: "Gold Membership",
    active: "Active",
  },
  {
    id: 4,
    name: "Bob Brown",
    scheme: "Silver Membership",
    active: "Inactive",
  },
];
export const MASTER_CONTRACT_DATA = [
  {
    id: 1,
    name: "John Doe",
    active: "Active",
  },
  {
    id: 2,
    name: "Jane Smith",
    active: "Inactive",
  },
  {
    id: 3,
    name: "Alice Johnson",
    active: "Active",
  },
  {
    id: 4,
    name: "Bob Williams",
    active: "Inactive",
  },
  {
    id: 5,
    name: "Charlie Brown",
    active: "Active",
  },
];
export const MASTER_COUNTRY_DATA = [
  {
    id: 1,
    country: "United States",
    standardCode: "+1",
    prefix: "US",
    status: "Active",
  },
  {
    id: 2,
    country: "India",
    standardCode: "+91",
    prefix: "IN",
    status: "Active",
  },
  {
    id: 3,
    country: "United Kingdom",
    standardCode: "+44",
    prefix: "UK",
    status: "Inactive",
  },
  {
    id: 4,
    country: "Canada",
    standardCode: "+1",
    prefix: "CA",
    status: "Active",
  },
  {
    id: 5,
    country: "Australia",
    standardCode: "+61",
    prefix: "AU",
    status: "Inactive",
  },
];
export const MASTER_STATE_DATA = [
  {
    id: 1,
    stateName: "California",
    country: "United States",
    status: "Active",
  },
  {
    id: 2,
    stateName: "Maharashtra",
    country: "India",
    status: "Active",
  },
  {
    id: 3,
    stateName: "Queensland",
    country: "Australia",
    status: "Inactive",
  },
  {
    id: 4,
    stateName: "Bavaria",
    country: "Germany",
    status: "Active",
  },
  {
    id: 5,
    stateName: "Ontario",
    country: "Canada",
    status: "Inactive",
  },
];
export const MASTER_CITY_DATA = [
  {
    id: 1,
    cityName: "New York",
    stateName: "New York",
    country: "United States",
    status: "Active",
  },
  {
    id: 2,
    cityName: "Mumbai",
    stateName: "Maharashtra",
    country: "India",
    status: "Active",
  },
  {
    id: 3,
    cityName: "Sydney",
    stateName: "New South Wales",
    country: "Australia",
    status: "Inactive",
  },
  {
    id: 4,
    cityName: "Berlin",
    stateName: "Berlin",
    country: "Germany",
    status: "Active",
  },
  {
    id: 5,
    cityName: "Toronto",
    stateName: "Ontario",
    country: "Canada",
    status: "Inactive",
  },
];
export const MASTER_RELATIONSHIP_DATA = [
  {
    relationship: "Father",
    active: true,
  },
  {
    relationship: "Mother",
    active: false,
  },
  {
    relationship: "Sibling",
    active: true,
  },
  {
    relationship: "Spouse",
    active: false,
  },
];
export const MASTER_BLOOD_GROUP_DATA = [
  {
    bloodGroup: "A+",
    active: true,
  },
  {
    bloodGroup: "O-",
    active: false,
  },
  {
    bloodGroup: "B+",
    active: true,
  },
  {
    bloodGroup: "AB-",
    active: false,
  },
];
export const MASTER_DOCTOR_REFERENCE_DATA = [
  {
    referenceDoctorName: "Dr. A. Sharma",
    active: true,
  },
  {
    referenceDoctorName: "Dr. B. Gupta",
    active: false,
  },
  {
    referenceDoctorName: "Dr. C. Verma",
    active: true,
  },
  {
    referenceDoctorName: "Dr. D. Patel",
    active: false,
  },
];

export const PHARMACY_IPD_LIST = [
  {
    requestDate: "2025-02-20",
    uhid: "KSG-24-0000010",
    name: "John Doe",
    requestedBy: "Dr. Smith",
    wardName: "Ward A",
    bedNumber: "12B",
    expectedDelivery: "2025-02-22",
    status: "Pending",
  },
  {
    requestDate: "2025-02-21",
    uhid: "KSG-24-0000011",
    name: "Jane Doe",
    requestedBy: "Dr. Brown",
    wardName: "Ward B",
    bedNumber: "7A",
    expectedDelivery: "2025-02-23",
    status: "Returned",
  },
  {
    requestDate: "2025-02-19",
    uhid: "KSG-24-0000012",
    name: "Alice Johnson",
    requestedBy: "Dr. Green",
    wardName: "Ward C",
    bedNumber: "5C",
    expectedDelivery: "2025-02-21",
    status: "Delivered",
  },
  {
    requestDate: "2025-02-18",
    uhid: "KSG-24-0000013",
    name: "Bob Williams",
    requestedBy: "Dr. White",
    wardName: "Ward D",
    bedNumber: "10D",
    expectedDelivery: "2025-02-20",
    status: "Pending",
  },
];
export const PHARMACY_OPD_LIST = [
  {
    date: "2025-02-20",
    uhid: "KSG-24-0000014",
    name: "David Miller",
    contactNumber: "9876543201",
    requestedBy: "Dr. Adams",
    invoiceNumber: "INV-201",
    status: "Pending",
  },
  {
    date: "2025-02-21",
    uhid: "KSG-24-0000015",
    name: "Sarah Johnson",
    contactNumber: "9876543202",
    requestedBy: "Dr. Brown",
    invoiceNumber: "INV-202",
    status: "Delivered",
  },
  {
    date: "2025-02-19",
    uhid: "KSG-24-0000016",
    name: "Robert Lee",
    contactNumber: "9876543203",
    requestedBy: "Dr. Green",
    invoiceNumber: "INV-203",
    status: "Returned",
  },
  {
    date: "2025-02-18",
    uhid: "KSG-24-0000017",
    name: "Emily Clark",
    contactNumber: "9876543204",
    requestedBy: "Dr. White",
    invoiceNumber: "INV-204",
    status: "Pending",
  },
];

export const PHARMACY_OUTSIDER_LIST = [
  {
    date: "2025-02-20",
    uhid: "KSG-24-0000018",
    name: "Michael Scott",
    contactNumber: "9876543210",
    requestedBy: "Self",
    invoiceNumber: "INV-101",
    status: "Pending",
  },
  {
    date: "2025-02-21",
    uhid: "KSG-24-0000019",
    name: "Dwight Schrute",
    contactNumber: "9876543211",
    requestedBy: "Self",
    invoiceNumber: "INV-102",
    status: "Delivered",
  },
  {
    date: "2025-02-19",
    uhid: "KSG-24-0000020",
    name: "Pam Beesly",
    contactNumber: "9876543212",
    requestedBy: "Self",
    invoiceNumber: "INV-103",
    status: "Returned",
  },
  {
    date: "2025-02-18",
    uhid: "KSG-24-0000021",
    name: "Jim Halpert",
    contactNumber: "9876543213",
    requestedBy: "Self",
    invoiceNumber: "INV-104",
    status: "Pending",
  },
];
export const REPORTS_CANCEL_APP_DATA = [
  {
    serialNumber: 1,
    patientId: "P12345",
    patientName: "John Doe",
    amount: 5000,
    receiptNumber: "REC001",
    clearDate: "2024-02-10",
    name: "Dr. Smith",
  },
  {
    serialNumber: 2,
    patientId: "P12346",
    patientName: "Jane Doe",
    amount: 7500,
    receiptNumber: "REC002",
    clearDate: "2024-02-11",
    name: "Dr. Brown",
  },
  {
    serialNumber: 3,
    patientId: "P12347",
    patientName: "Alice Johnson",
    amount: 3000,
    receiptNumber: "REC003",
    clearDate: "2024-02-12",
    name: "Dr. Miller",
  },
  {
    serialNumber: 4,
    patientId: "P12348",
    patientName: "Bob Williams",
    amount: 4500,
    receiptNumber: "REC004",
    clearDate: "2024-02-13",
    name: "Dr. Davis",
  },
  {
    serialNumber: 5,
    patientId: "P12349",
    patientName: "Charlie Brown",
    amount: 6000,
    receiptNumber: "REC005",
    clearDate: "2024-02-14",
    name: "Dr. Wilson",
  },
];
export const REPORTS_CANCELLED_DATA = [
  {
    serialNumber: 1,
    patientId: "P1001",
    patientName: "John Doe",
    visitType: "OPD",
    amount: 5000,
    receiptNumber: "RCPT12345",
    clearDate: "2024-02-10",
    name: "Dr. Smith",
  },
  {
    serialNumber: 2,
    patientId: "P1002",
    patientName: "Jane Doe",
    visitType: "IPD",
    amount: 7500,
    receiptNumber: "RCPT12346",
    clearDate: "2024-02-11",
    name: "Dr. Brown",
  },
  {
    serialNumber: 3,
    patientId: "P1003",
    patientName: "Alice Johnson",
    visitType: "Emergency",
    amount: 3000,
    receiptNumber: "RCPT12347",
    clearDate: "2024-02-12",
    name: "Dr. Williams",
  },
  {
    serialNumber: 4,
    patientId: "P1004",
    patientName: "Bob Martin",
    visitType: "OPD",
    amount: 6200,
    receiptNumber: "RCPT12348",
    clearDate: "2024-02-13",
    name: "Dr. Davis",
  },
  {
    serialNumber: 5,
    patientId: "P1005",
    patientName: "Charlie White",
    visitType: "IPD",
    amount: 8400,
    receiptNumber: "RCPT12349",
    clearDate: "2024-02-14",
    name: "Dr. Wilson",
  },
];
export const DUMMY_TABLE_DATA_REPORTS_EXPENSE_DETAIL_STATEMENT = [
  {
    _id: "1",
    uhid: "KSG-24-0000022",
    patientName: "John Doe",
    regDate: "2024-02-01",
    dischargeDate: "2024-02-05",
    consulatationCharges: 500,
    procedureCharges: 1500,
  },
  {
    _id: "2",
    uhid: "KSG-24-0000023",
    patientName: "Jane Smith",
    regDate: "2024-02-03",
    dischargeDate: "2024-02-07",
    consulatationCharges: 700,
    procedureCharges: 2000,
  },
  {
    _id: "3",
    uhid: "KSG-24-0000024",
    patientName: "Michael Johnson",
    regDate: "2024-02-05",
    dischargeDate: "2024-02-10",
    consulatationCharges: 450,
    procedureCharges: 1700,
  },
  {
    _id: "4",
    uhid: "KSG-24-0000025",
    patientName: "Emily Davis",
    regDate: "2024-02-06",
    dischargeDate: "2024-02-12",
    consulatationCharges: 600,
    procedureCharges: 1800,
  },
  {
    _id: "5",
    uhid: "KSG-24-0000026",
    patientName: "Chris Brown",
    regDate: "2024-02-08",
    dischargeDate: "2024-02-14",
    consulatationCharges: 550,
    procedureCharges: 1600,
  },
];
export const PATIENT_ADVANCE_PAYMENT_REPORT = [
  {
    _id: "1",
    visitNo: "V001",
    uhid: "KSG-24-0000027",
    patientName: "John Doe",
    regDate: "2024-02-10",
    dischargeDate: "2024-02-15",
    category: "General",
    procedureCharges: 2000,
  },
  {
    _id: "2",
    visitNo: "V002",
    uhid: "KSG-24-0000028",
    patientName: "Jane Smith",
    regDate: "2024-02-12",
    dischargeDate: "2024-02-18",
    category: "Private",
    procedureCharges: 2500,
  },
  {
    _id: "3",
    visitNo: "V003",
    uhid: "KSG-24-0000029",
    patientName: "Michael Johnson",
    regDate: "2024-02-14",
    dischargeDate: "2024-02-20",
    category: "General",
    procedureCharges: 1800,
  },
  {
    _id: "4",
    visitNo: "V004",
    uhid: "KSG-24-0000030",
    patientName: "Emily Davis",
    regDate: "2024-02-16",
    dischargeDate: "2024-02-22",
    category: "Private",
    procedureCharges: 3000,
  },
  {
    _id: "5",
    visitNo: "V005",
    uhid: "KSG-24-0000031",
    patientName: "Chris Brown",
    regDate: "2024-02-18",
    dischargeDate: "2024-02-24",
    category: "General",
    procedureCharges: 2200,
  },
];
export const IPD_DISCHARGE_PATIENT_REPORT_DATA = [
  {
    id: 1,
    serialNumber: 1,
    patientId: "PID1001",
    age: 35,
    sex: "Male",
    address: "123 Main St, New York, NY",
  },
  {
    id: 2,
    serialNumber: 2,
    patientId: "PID1002",
    age: 28,
    sex: "Female",
    address: "456 Elm St, Los Angeles, CA",
  },
  {
    id: 3,
    serialNumber: 3,
    patientId: "PID1003",
    age: 42,
    sex: "Male",
    address: "789 Oak St, Chicago, IL",
  },
  {
    id: 4,
    serialNumber: 4,
    patientId: "PID1004",
    age: 30,
    sex: "Female",
    address: "101 Pine St, Houston, TX",
  },
  {
    id: 5,
    serialNumber: 5,
    patientId: "PID1005",
    age: 50,
    sex: "Male",
    address: "202 Maple St, Miami, FL",
  },
];
export const IPD_PATIENT_SUMMARY = [
  {
    id: 1,
    sno: 1,
    patientId: "PID1001",
    patientname: "John Doe",
    age: 35,
    sex: "Male",
    ward: "General",
  },
  {
    id: 2,
    sno: 2,
    patientId: "PID1002",
    patientname: "Jane Smith",
    age: 28,
    sex: "Female",
    ward: "ICU",
  },
  {
    id: 3,
    sno: 3,
    patientId: "PID1003",
    patientname: "Michael Johnson",
    age: 42,
    sex: "Male",
    ward: "Emergency",
  },
  {
    id: 4,
    sno: 4,
    patientId: "PID1004",
    patientname: "Emily Davis",
    age: 30,
    sex: "Female",
    ward: "Surgery",
  },
  {
    id: 5,
    sno: 5,
    patientId: "PID1005",
    patientname: "Robert Brown",
    age: 50,
    sex: "Male",
    ward: "General",
  },
];
export const PATIENT_INDENT_LEDGER_DATA = [
  {
    id: 1,
    sno: 1,
    requestNo: "REQ1001",
    requestingStore: "Pharmacy",
    issuingStore: "Main Warehouse",
    ipStatus: "Pending",
    patientUhid: "KSG-24-0000022",
    patientName: "John Doe",
  },
  {
    id: 2,
    sno: 2,
    requestNo: "REQ1002",
    requestingStore: "Surgical",
    issuingStore: "Central Supply",
    ipStatus: "Approved",
    patientUhid: "KSG-24-0000023",
    patientName: "Jane Smith",
  },
  {
    id: 3,
    sno: 3,
    requestNo: "REQ1003",
    requestingStore: "ICU",
    issuingStore: "Emergency Stock",
    ipStatus: "Dispatched",
    patientUhid: "KSG-24-0000024",
    patientName: "Michael Johnson",
  },
  {
    id: 4,
    sno: 4,
    requestNo: "REQ1004",
    requestingStore: "General Ward",
    issuingStore: "Main Warehouse",
    ipStatus: "Pending",
    patientUhid: "KSG-24-0000025",
    patientName: "Emily Davis",
  },
  {
    id: 5,
    sno: 5,
    requestNo: "REQ1005",
    requestingStore: "Cardiology",
    issuingStore: "Pharmacy",
    ipStatus: "Approved",
    patientUhid: "KSG-24-0000026",
    patientName: "Robert Brown",
  },
];
export const CANCEL_PAYMENT_REPORT_DATA = [
  {
    id: 1,
    title: "Consultation Fee",
    receiptNo: "REC1001",
    payslip: "PAYSLIP001",
    amount: 500,
    transactionType: "Credit",
    paymentType: "Cash",
  },
  {
    id: 2,
    title: "Laboratory Test",
    receiptNo: "REC1002",
    payslip: "PAYSLIP002",
    amount: 1200,
    transactionType: "Debit",
    paymentType: "Card",
  },
  {
    id: 3,
    title: "Pharmacy Purchase",
    receiptNo: "REC1003",
    payslip: "PAYSLIP003",
    amount: 750,
    transactionType: "Credit",
    paymentType: "UPI",
  },
  {
    id: 4,
    title: "Admission Charges",
    receiptNo: "REC1004",
    payslip: "PAYSLIP004",
    amount: 5000,
    transactionType: "Debit",
    paymentType: "Bank Transfer",
  },
  {
    id: 5,
    title: "Surgery Fee",
    receiptNo: "REC1005",
    payslip: "PAYSLIP005",
    amount: 15000,
    transactionType: "Credit",
    paymentType: "Insurance",
  },
];

export const BILL_DETAIL_REPORT_DATA = [
  {
    id: 1,
    sno: 1,
    billDate: "2025-02-25",
    patientUhid: "KSG-24-0000032",
    billNumber: "BILL1001",
    visitNo: "VST2001",
    status: "Paid",
    patientName: "John Doe",
  },
  {
    id: 2,
    sno: 2,
    billDate: "2025-02-24",
    patientUhid: "KSG-24-0000033",
    billNumber: "BILL1002",
    visitNo: "VST2002",
    status: "Pending",
    patientName: "Jane Smith",
  },
  {
    id: 3,
    sno: 3,
    billDate: "2025-02-23",
    patientUhid: "KSG-24-0000034",
    billNumber: "BILL1003",
    visitNo: "VST2003",
    status: "Cancelled",
    patientName: "Alice Johnson",
  },
  {
    id: 4,
    sno: 4,
    billDate: "2025-02-22",
    patientUhid: "KSG-24-0000035",
    billNumber: "BILL1004",
    visitNo: "VST2004",
    status: "Paid",
    patientName: "Michael Brown",
  },
  {
    id: 5,
    sno: 5,
    billDate: "2025-02-21",
    patientUhid: "KSG-24-0000036",
    billNumber: "BILL1005",
    visitNo: "VST2005",
    status: "Pending",
    patientName: "Emma Wilson",
  },
];
export const MASTER_PACKAGE_DATA = [
  {
    id: 1,
    code: "A101",
    name: "John Doe",
    type: "Admin",
    status: "Active",
  },
  {
    id: 2,
    code: "B202",
    name: "Jane Smith",
    type: "User",
    status: "Inactive",
  },
  {
    id: 3,
    code: "C303",
    name: "Michael Brown",
    type: "Editor",
    status: "Active",
  },
  {
    id: 4,
    code: "D404",
    name: "Emily Davis",
    type: "Moderator",
    status: "Pending",
  },
  {
    id: 5,
    code: "E505",
    name: "Chris Wilson",
    type: "Admin",
    status: "Active",
  },
];
